import { render, staticRenderFns } from "./ListAllNotifications.vue?vue&type=template&id=540b4a40&"
import script from "./ListAllNotifications.vue?vue&type=script&lang=js&"
export * from "./ListAllNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports